/**
 * Single source of truth for reconciling the three field-name namespaces used
 * by the manifest drawer:
 *  - `ManifestDiscrepancy.field` (backend discrepancy rows),
 *  - `WasteLineUnified.fieldSources[].field` (line-item provenance),
 *  - the UI field key each `InfoBox` is rendered under.
 *
 * Most names line up 1:1; the entries below are the ones that DON'T, so the
 * validation-warning Set and the per-field source dots reference the same key.
 */

/** Line-item `fieldSources.field` names emitted by the WasteLineUnified resolver. */
export const LINE_ITEM_FIELD_KEYS = [
  "lineItem",
  "dotDescription",
  "profileNumber",
  "federalWasteCodes",
  "stateWasteCodes",
  "managementMethodCode",
  "formCode",
  "sourceCode",
  "amount",
] as const;

/**
 * Aliases from `ManifestDiscrepancy.field` → the UI field key used by the
 * rendered field. Anything not listed maps to itself.
 *
 * - `quantity` (discrepancy) is rendered as the single `amount` field.
 * - `dotPrintedInformation` / `nonHazWasteDescription` collapse into the
 *   `dotDescription` field the drawer shows.
 */
const DISCREPANCY_FIELD_TO_UI_KEY: Record<string, string> = {
  quantity: "amount",
  dotPrintedInformation: "dotDescription",
  nonHazWasteDescription: "dotDescription",
};

export function discrepancyFieldToUiKey(field: string): string {
  return DISCREPANCY_FIELD_TO_UI_KEY[field] ?? field;
}
